import { Ref, TwinPair } from 'src/util';

import Player from './Player';

type Game = {
  players: TwinPair<Ref<Player>>,
  outcome: 'win' | 'loss' | 'draw',
  ref: Ref<Game>,
};

function Game({ players, outcome }: {
  players: TwinPair<Ref<Player>>;
  outcome: Game.Outcome;
}): Game {
  return {
    players,
    outcome,
    ref: Ref<Game>(),
  };
}

namespace Game {
  export type Outcome = 'win' | 'loss' | 'draw';

  export const outcomes: Outcome[] = [
    'win',
    'loss',
    'draw',
  ];

  export type Suggestion = {
    players: TwinPair<Ref<Player>>,
    value: number,
  };
}

export default Game;



// WEBPACK FOOTER //
// ./src/state/Game.ts